import axios from 'axios';

// Создаем axios инстанс с базовой конфигурацией
const api = axios.create({
  baseURL: 'api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Добавляем interceptor для автоматического добавления JWT токена
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token && token.trim() !== '') {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Добавляем interceptor для обработки ошибок
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Мягкая обработка 401: очищаем сессию и инициируем logout-событие без перезагрузки страницы
      try { localStorage.removeItem('token'); } catch {}
      try { localStorage.removeItem('user'); } catch {}
      try { window.dispatchEvent(new Event('auth:unauthorized')); } catch {}
    }
    return Promise.reject(error);
  }
);

export { api };
